import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgxWavesurferModule } from 'ngx-wavesurfer';
import { NgxWavesurferServiceDemoComponent } from './ngx-wavesurfer-service-demo/ngx-wavesurfer-service-demo.component';
import { NgxWavesurferComponentDemoComponent } from './ngx-wavesurfer-component-demo/ngx-wavesurfer-component-demo.component';
import { NgxWavesurferSingleComponent } from './ngx-wavesurfer-single/ngx-wavesurfer-single.component';

@NgModule({
  imports: [BrowserModule, AppRoutingModule, FormsModule, NgxWavesurferModule],
  declarations: [
    AppComponent,
    NgxWavesurferServiceDemoComponent,
    NgxWavesurferComponentDemoComponent,
    NgxWavesurferSingleComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
